package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_02_08_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-02-08")
@Composable
public fun Log_2025_02_08(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "1100-year-old noble found dead",
        ogTitle = "1100-year-old noble found dead",
        date = LocalDate(2_025, 2, 8),
        aiHint = "Image, title, and description inaccurately reimagine the heroes' defeat of a evil dragon as a crime.",
        ogDescription = "A shadowy unnamed gang of youths from Malus break into elderly woman’s home and kill her. ",
        ogImage = "ai/2025-02-08.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-74", dateString = "Newgrowth 74")
        Log_2025_02_08_Day_1()
    }
}
